export enum MoneyTransactionType {
Transfer,
Withdraw,
Deposit,
Collection,
Payment,
Other,
}
